import { useEffect, useState } from 'react';
import api from '../services/api';

// The logged-in user's OPEN positions (owner 2026-10-16: "sell only an existing position") - polled every 10 s,
// keeps the last good list on a failed poll. Helpers say whether a SELL button should be shown.
export default function useMyPositions() {
  const [list, setList] = useState([]);
  useEffect(() => {
    let alive = true;
    const q = async () => {
      try {
        const r = await api.getStatus();
        const p = r && r.positions;
        if (!alive || !p) return;
        setList(Array.isArray(p) ? p : Object.entries(p).map(([k, v]) => ({ key: k, ...(v || {}) })));
      } catch (e) { /* keep last */ }
    };
    q(); const iv = setInterval(q, 10000);
    return () => { alive = false; clearInterval(iv); };
  }, []);
  const ts = (v) => String(v.trade_symbol || v.symbol || v.key || '').toUpperCase().split(':').pop().split('#')[0];
  const und = (v) => String(v.underlying || String(v.key || '').split('#')[0] || '').toUpperCase();
  const clean = (s) => String(s || '').toUpperCase().split(':').pop().replace('-EQ', '');
  return {
    positions: list,
    // this exact contract / stock is held
    holds: (sym) => { const s = clean(sym); return list.some(v => ts(v).replace('-EQ', '') === s); },
    // every open position on this symbol: the contract itself, or any option / stock of this underlying
    heldOn: (sym) => { const s = clean(sym); return list.filter(v => ts(v).replace('-EQ', '') === s || und(v) === s); },
    // a CE or PE on this underlying is held
    holdsType: (underlying, ot) => { const u = clean(underlying); return list.some(v => und(v) === u && ts(v).endsWith(ot)); },
  };
}
